// extracted by mini-css-extract-plugin
module.exports = {"action-icon":"AssortmentBuilder_action-icon__2pwtE","actions":"AssortmentBuilder_actions__3bvi6"};